<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered
          .column
            h3.is-size-3  
              | Reingreso de Consumibles
              | &nbsp
              a.button.is-dark.is-rounded.is-medium(@click='backPage')
                i.fas.fa-times
        .columns
          .column.is-4
            Typeahead(:options="usuarios" :optionSelect="usuariosSel" v-model="usuariosSel")
          .column.is-6
            Typeahead(:options="consumibles" :optionSelect="itemData" v-model="itemSel")
        .columns
          .column.is-12
            FormItem_Cons_Reingreso(:consumible="itemSel" @addCons_Reingreso="addCons_Reingreso" v-show="addCons")
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Consumibles para reingreso
                  | &nbsp
                  span.tag.is-black(v-if="consumibles_reingreso_items > 0")
                    | {{ consumibles_reingreso_items }} consumible(s) para la salida.
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                    ListCons_Reingreso(:consumibles="consumibles_reingreso" @deleteCons="deleteCons")
        .columns
          .column.is-offset-5.is-2
            a.button.is-rounded(:disabled="!activarGuardar" :class="claseButton" @click="guardarReingreso")
              | Guardar Reingreso
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import Typeahead from './Typeahead.vue'
  import FormItem_Cons_Reingreso from './FormItem_Cons_Reingreso.vue'
  import ListCons_Reingreso from './ListCons_Reingreso.vue'
  import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
  import InventarioServices from '../../services/inventario/inventario'
  import usuariosServices from '@/services/usuarios/usuarios'
  import moment from 'moment'

  import { mapState } from 'vuex'

  export default {
    name: 'ContainerReingreso_Cons',
    components: { Loader, NavBarInventario, Typeahead, FormItem_Cons_Reingreso, ListCons_Reingreso, BulmaAccordion, BulmaAccordionItem },
    data() {
      return {
        isLoading: true,
        items_reingreso: [],
        consumibles: [],
        itemData: {},
        itemSel: {},
        habilitatarForm: false,
        consumibles_reingreso: [],
        consumibles_reingreso_exit: [],
        consumibles_reingreso_items: 0,
        usuarios: [],
        usuariosSel: {},
        dataForm: {},
        activarGuardar: false,
        formCompleto: false,
        claseButton: 'is-light',
        consumibles_guardados: 0,
        addCons: false
      }
    },
    watch: {
      consumibles_reingreso() {
        console.log('consumibles_reingreso_change')
        this.checkCantidad()
        this.checkFormularios()
      },
      formCompleto() {
        if (this.formCompleto) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
        } else {
          this.activarGuardar = false
          this.claseButton = 'is-light'
        }
      },
      dataForm () {
        this.checkFormularios()
      },
      usuariosSel() {
        this.obtenerConsumibles()
      },
      itemSel () {
        console.log('itemsel changed')
        if (this.consumibles_reingreso.length > 0) {
          this.consumibles_reingreso.forEach(item => {
            if (item.idconsumible === this.itemSel.idconsumible) {
              this.displayToast(`El consumible ${item.descripcion} ya se encuentra ingresado.`, 'ban', 'Ok')
              this.addCons = false
            } else {
              if (Object.keys(this.itemSel).length > 0) {
                this.addCons = true
              } else {
                this.addCons = false
              }
            }
          })
        } else {
          if (Object.keys(this.itemSel).length > 0) {
            this.addCons = true
          } else {
            this.addCons = false
          }
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerUsuarios()
      },

      obtenerConsumibles() {
        InventarioServices.getItems_User_SalidasCons(this.usuariosSel.id)
          .then(res => {
            console.log(res)
            if (res.length > 0) {
              this.hayDatos = true
              this.consumibles = res.map(this.convertirConsumibles)
            } else {
              this.hayDatos = false
            }
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`)
          })
      },

      obtenerUsuarios () {
        InventarioServices.getUsuarios_SalidasCons(this.userLogin.ubicacion)
          .then( res => {
            this.usuarios = res.map(this.convetirDataUsuarios)
            this.isLoading = false
          })
          .catch( e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`)
          })
      },
      convetirDataUsuarios(user) {
        return {
          ...user,
          id: user.id_recibe,
          text: user.recibe
        }
      },

      convertirConsumibles (cons) { 
        return {
          ...cons,
          id: parseInt(cons.id),
          idSalida: parseInt(cons.idSalida),
          idconsumible: parseInt(cons.idconsumible),
          cantidad_e: parseInt(cons.cantidad_e),
          cantidad_t: parseInt(cons.cantidad_t),
          cantidad_r: parseInt(cons.cantidad_r),
          text: `(${cons.cantidad_r}) ${cons.descripcion}`
        }
      },
      
      addCons_Reingreso (cons) {
        if (this.addCons) {
          this.consumibles_reingreso.push(cons)
          this.itemSel = {}
          this.addCons = false
        }
        this.checkCantidad()
      },

      deleteCons (cons) {
        let indexOf = this.consumibles_reingreso.findIndex( i => i.id === cons.id)
        this.consumibles_reingreso.splice(indexOf,1)
        this.itemSel = {}
        this.itemData = {}
        this.addCons = false
        this.checkCantidad()
      },
      
      checkFormularios() {
        console.log('Check Formularios')
        if (this.consumibles_reingreso.length > 0) {
          console.log('Items y Formulario')
          this.formCompleto = true
        } else {
          console.log('Falta Item y/o Formulario')
          this.formCompleto = false
        }
      },
      checkCantidad() {
        const total = this.consumibles_reingreso.reduce( (acc, el) => {
          return acc + el.cantidadIn 
        },0)
        this.consumibles_reingreso_items = total
      },
      guardarReingreso () {
        console.log('guardar registro')
        let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
        let almacen = ''
        switch (this.userLogin.ubicacion) {
          case 'TPA':
            almacen = 'TPA-ALS'
            break
          case 'EB04':
            almacen = 'EB04-ALG'
            break
          case 'CORP':
            almacen = 'COPR-ALM'
            break
          case 'IRGE':
            almacen = 'IRGE-ALM'
            break
          default:
            almacen = ''
            break
        }

        this.consumibles_reingreso.forEach(cons => {
          InventarioServices.addConsumibleBack(fechaReg,cons.idconsumible, cons.id, cons.cantidadIn, cons.ubicacion, this.userLogin.ubicacion, almacen, this.usuariosSel.id, this.usuariosSel.text, this.userLogin.id, this.userLogin.nombre)
            .then( (data) => {
              console.log(data)
              if (data.success) {
                this.consumibles_guardados = this.consumibles_guardados + 1
                if (this.consumibles_guardados == this.consumibles_reingreso.length) {
                  this.displayToast('Se ha registrado el reingreso de los consumibles.', 'done', 'Ok')
                  this.backPage()
                } else {
                  console.log(`Se Guardaron ${this.itemsGuardados} consumibles de ${this.consumibles_reingreso.length}`)
                }

              } else {
                this.isLoading = false
                this.displayToast(`Error: ${data.respuesta}`,'ban', 'Ok')
              }
              
            })
            .catch( (e) => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`,'ban', 'Ok')
            })
        })
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },
      firmarReingresoCons(consumible) {
        // this.$store.commit('firmarSalidaConsumible', consumible)
        // this.$router.push('/Inventario/Consumibles/Firmar')
      },
      backPage () {
      this.$router.back()
    },  
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/ContainerReingreso_Cons.vue